import axios from 'axios';
import { configsWithCredentials, defaultConfigs } from './configs';
import { requestInterceptor, responseInterceptorFullFilled, responseInterceptorRejected } from './interceptors';

const apiService = axios.create({
  baseURL: process.env.BFF_URL,
  ...configsWithCredentials,
});

apiService.interceptors.request.use(requestInterceptor, (err) => Promise.reject(err));
apiService.interceptors.response.use(responseInterceptorFullFilled, responseInterceptorRejected);

const contactListService = axios.create({
  ...configsWithCredentials,
  baseURL: process.env.BFF_CONTACT_LIST_URL,
});

contactListService.interceptors.request.use(requestInterceptor, (err) => Promise.reject(err));
contactListService.interceptors.response.use(responseInterceptorFullFilled, responseInterceptorRejected);

const trackingService = axios.create({
  baseURL: process.env.API_GATEWAY_BASE_URI,
  timeout: 1000,
  headers: {
    ...defaultConfigs.headers,
    'Event-Type': 'events',
  },
});

const centralApiService = axios.create({
  baseURL: process.env.CENTRAL_URL,
  withCredentials: true,
  withXSRFToken: true,
  timeout: 60000,
  headers: {
    'content-Type': 'application/json',
    Accept: '/',
  },
});

export { apiService, contactListService, trackingService, centralApiService };
